import * as React from 'react';

import { trackPurchaseTermClick } from './tracking';
import { PurchaseTermCell } from '../../components/PurchaseTermCell';
import { IDescriptionDialog, IPurchaseOption } from '../../types/purchaseTerm';

interface IPurchaseTermsCellProps {
  term: IPurchaseOption;
  onClick: (term: IDescriptionDialog) => void;
}

export const PurchaseTermsCellContainer = ({ term, onClick }: IPurchaseTermsCellProps) => {
  /* istanbul ignore next */
  const handleClick = React.useCallback(() => {
    if (!term.descriptionDialog) {
      return;
    }

    onClick(term.descriptionDialog);

    trackPurchaseTermClick({ type: term.priceType, source: 'DifferentPrices' });
  }, [term, onClick]);

  return (
    <PurchaseTermCell
      onClick={handleClick}
      title={term.title}
      label={term.label}
      price={term.price}
      pricePerMeter={term.pricePerMeter}
      descriptionDialog={term.descriptionDialog}
    />
  );
};
